// removed by extract-text-webpack-plugin
module.exports = {"appBar":"mv5hVcwTNIJ1rYrDRK8AI","veryweak":"_2mCVxVTMPvkYEK7YlHeJSc","weak":"_3TX5aa0mWkT_IrIKVukHl7","avatar":"_2fUFdBajYAJt9GQG3WDv1d"};